// 案件インポートのデフォルトマッピング（組み込み項目 → 既定CSV列名）
export const baseDefaultMappings: Record<string, string> = {
  code: '伝票No',
  delivery_method: '配送形態',
  section_type: '区間種別',
  shipper_name: '荷主名',
  shipper_contact_person: '荷主担当者',
  shipper_phone_number: '荷主電話番号',
  shipper_email_address: '荷主メールアドレス',
  loading_name: '積地',
  loading_internal_location_code: '積地コード',
  loading_address: '積地住所',
  loading_on: '積日',
  loading_at_start: '積地受付',
  loading_at_end: '積地締切',
  loading_at_start_two: '積地受付②',
  loading_at_end_two: '積地締切②',
  loading_at_start_three: '積地受付③',
  loading_at_end_three: '積地締切③',
  loading_staying_minutes: '積地作業分数',
  unloading_name: '降地名称',
  unloading_internal_location_code: '降地コード',
  unloading_address: '降地住所',
  unloading_on: '降日',
  unloading_at_start: '降地受付',
  unloading_at_end: '降地締切',
  unloading_at_start_two: '降地受付②',
  unloading_at_end_two: '降地締切②',
  unloading_at_start_three: '降地受付③',
  unloading_at_end_three: '降地締切③',
  unloading_staying_minutes: '降地作業分数',
  item_count: '数量',
  item_total_weight_kg: '総重量',
  item_total_volume_m3: '総体積',
  item_klass: '輸送区分',
  item_code: '商品コード',
  item_name: '品名',
  item_lot_number: 'ロットNo',
  item_custom_order_number: '特注No',
  item_packing_style: '荷姿',
  item_handling_of_cargo_style: '荷扱い',
  item_can_be_mixed: '混載可否',
  designated_truck_klasses: '車両タイプ',
  designated_truck_car_models: '指定車種',
  designated_truck_loading_platform_heights: '荷台高',
  designated_truck_loading_platform_widths: '荷台幅',
  designated_truck_loading_platform_lengths: '荷台長',
  designated_truck_floor_specifications: '床仕様',
  designated_truck_features: '指定装置・特徴',
  billing_basic_fee_yen: '請求 基本運賃',
  billing_surcharge_fee_yen: '請求 サーチャージ料',
  billing_relay_fee_yen: '請求 中継料',
  billing_highway_fee_yen: '請求 高速代金',
  billing_loading_fee_yen: '請求 積込料金',
  billing_ancillary_fee_yen: '請求 付帯作業料金',
  billing_waiting_time_fee_yen: '請求 待機料金',
  billing_unloading_fee_yen: '請求 取卸料',
  billing_expenses_fee_yen: '請求 諸経費',
  billing_ancillary_content: '請求 付帯作業備考',
  payment_basic_fee_yen: '支払 基本運賃',
  payment_surcharge_fee_yen: '支払 サーチャージ料',
  payment_relay_fee_yen: '支払 中継料',
  payment_highway_fee_yen: '支払 高速代金',
  payment_loading_fee_yen: '支払 積込料金',
  payment_ancillary_fee_yen: '支払 付帯作業料金',
  payment_waiting_time_fee_yen: '支払 待機料金',
  payment_unloading_fee_yen: '支払 取卸料',
  payment_expenses_fee_yen: '支払 諸経費',
  payment_ancillary_content: '支払 付帯作業備考',
  memo: '備考',
  allowed_trucks: '指定トラック',
  denied_drivers: 'NGドライバー',
};

// 任意項目(custom_input_fields)を自名(項目名→項目名)で加えたデフォルトマッピングを返す。
// バックエンド ImportOrderParseJobV3#default_mappings と挙動を揃える。
export const buildDefaultMappings = (
  customInputFields: string[]
): Record<string, string> => ({
  ...baseDefaultMappings,
  ...Object.fromEntries(customInputFields.map((name) => [name, name])),
});
